import { createAction, getType } from "typesafe-actions";
import api from "../../services/api";
import { OutputTag } from "../../types/models";
import { ThunkResult } from "../../types/redux";
import { RootAction } from "../actions";

export type OutputTagsState = OutputTag[];

const initialState: OutputTagsState = [];

export const actions = {
  setOutputTags: createAction("@output_tags/setOutputTags")<OutputTag[]>(),
  addOutputTag: createAction("@output_tags/addOutputTag")<OutputTag>(),
};

export const getOutputTags =
  (clientId: number): ThunkResult<Promise<any>> =>
  (dispatch) => {
    return api
      .getOutputTags(clientId)
      .then((response) => dispatch(actions.setOutputTags(response)));
  };

export const createOutputTag =
  (clientId: number, name: string): ThunkResult<Promise<any>> =>
  (dispatch) => {
    return api
      .createOutputTag(clientId, name)
      .then((response) => dispatch(actions.addOutputTag(response)))
      .catch((error: any) => {
        // Handle error cases
        if (error.status === 400) {
          throw new Error("Missing name in body");
        }
        if (error.status === 404) {
          throw new Error("Invalid client_id");
        }
        if (error.status === 409) {
          throw new Error("Tag with that name already exists for the client");
        }
        throw error;
      });
  };

export default function reducer(
  state = initialState,
  action: RootAction
): OutputTagsState {
  switch (action.type) {
    case getType(actions.setOutputTags):
      return (action as any).payload;
    case getType(actions.addOutputTag):
      return [...state, (action as any).payload];
    default:
      return state;
  }
}
